import React from "react";
import { Routes, Route } from "react-router-dom";
import SiteVisitList from "../Components/SiteVisit/siteVisitList";
import ViewSiteVisit from "../Components/SiteVisit/viewSiteVisit";

const SiteVisitRoutes = () => {
  return (
    <Routes>
      <Route path="/site_visit" element={<SiteVisitList />} />
      <Route path="/site-visit/:id" element={<ViewSiteVisit />} />
    </Routes>
  );
};

export default SiteVisitRoutes;
